module.exports = __webpack_public_path__ + "assets/camera-icon-white.a18d63f5.svg";